var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-reset",attrs:{"type":"button"}},[_c('svgicon',{attrs:{"icon":"button/swiper-arrow","width":"9","height":"17"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }